export default "__VITE_ASSET__Be3dN9Hb__"